/**
 * App — T22 update.
 *
 * Wires React Router v6 BrowserRouter with the full route tree:
 *
 *   /            → BriefPage (protected)
 *   /runs/:id    → BriefPage with runId param (protected)
 *   /settings/*  → SettingsPage (protected)
 *   /login       → LoginPage (public)
 *   *            → NotFoundPage
 *
 * Protected routes are wrapped in AuthGuard which redirects to /login if no
 * access token is present. AppShellLayout provides the persistent header and
 * main content area for all protected pages.
 */
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShellLayout } from './components/AppShell';
import { AuthGuard } from './components/AuthGuard';
import BriefPage from './pages/BriefPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import SettingsPage from './pages/SettingsPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes — all share the AppShell layout */}
        <Route
          element={
            <AuthGuard>
              <AppShellLayout />
            </AuthGuard>
          }
        >
          <Route path="/" element={<BriefPage />} />
          {/* /runs/:id renders the same BriefPage; T25 reads the param to highlight the run */}
          <Route path="/runs/:id" element={<BriefPage />} />
          <Route path="/settings/*" element={<SettingsPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
